export const FirmwareGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            type: 'type',
            description: 'firmDescription',
            clientVersion: 'clientVersion',
            whatsNew: 'whatsNew',
            releaseDate: 'releaseDate',
            privateFirmware: 'privateFirmware',
            recommended: 'recommended',
            enabled: 'enabled'
        },
        history: {
            pageId: 'history',
            createTime: 'createTime',
            lastTime: 'lastTime'

        },
        serviceDomains: {
            pageId: 'serviceDomains',
            serviceDomainList: 'serviceDomainList',
            visible: 'visible'
        },
    }
}


export const FirmwareGetListSchema = {
    uid: 'uid',
    name: 'name',
    description: 'description',
    appliance: 'appliance',
    applianceValues: {
        type600:  '600/1100 Appliance',
        type1200: '1200R Appliance',
        typeS1S2: '700/1400 Appliance',
        typeV0V1: '1500/1500R Appliance',
        typeV2V3: '1600/1800 Appliances',
    },
    releaseDate: 'releaseDate',
    version: 'version',
    type: 'type',
    enabled: 'enabled'
}

export const FirmwareFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    appliance: 'appliance',
    applianceValues: {
        type600:  '600/1100 Appliance',
        type1200: '1200R Appliance',
        typeS1S2: '700/1400 Appliance',
        typeV0V1: '1500/1500R Appliance',
        typeV2V3: '1600/1800 Appliances'
    },
    type: 'type',
    typeValues: {
        generalAvailability: 'Check Point General Availability',
        customerHotfix: 'Customer Hotfix'
    },
    creationDate: 'creationDate',
    modificationDate: 'modificationDate'
}